import { KidsChoiceCategoryType, KidsChoiceSprite, KidsChoiceSpriteConfig, KidsChoiceSpriteType } from "../KidsChoiceTypes"
import { KidsChoiceCategoryContainer } from "./KidsChoiceCategoryContainer"
import { KidsChoiceVideoSelectContainer } from "./KidsChoiceVideoSelectContainer"

export class KidsChoiceSpriteCreator {

    activeSprites: Array<KidsChoiceSprite>

    constructor(private game: Phaser.Game) {
        this.activeSprites = []
    }

    destroyAll = () => this.activeSprites.forEach(sprite => sprite.destroy())

    create = (spriteType: KidsChoiceSpriteType, config?: KidsChoiceSpriteConfig): KidsChoiceSprite => {
        let currentType: KidsChoiceCategoryType
        let group: Phaser.Group
        let end: () => void
        if (config) {
            const {type, onEnd} = config
            end = onEnd
            currentType = type
            group = config.group ? config.group : this.game.add.group()
        }

        let sprite: KidsChoiceSprite
        switch (spriteType) {
            case KidsChoiceSpriteType.CATEGORY_SELECT:
                sprite = new KidsChoiceCategoryContainer(this.game, group)
                break
            case KidsChoiceSpriteType.VIDEO_SELECT:
                sprite = new KidsChoiceVideoSelectContainer(this.game, currentType, group, end)
                break
            default:
                throw new Error("Unimplemented sprite type.")
        }

        this.activeSprites.push(sprite)
        return sprite
    }
}
